import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BarChartComponent } from '../../../my-shared-lib/src/lib/chart-components/bar-chart/bar-chart.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { ChatTabsComponent } from '../../../my-shared-lib/src/lib/global-components/chat/chat-tabs.component';
import { LandingPageComponent } from '../../../my-shared-lib/src/lib/global-components/landing-page/landing-page.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full',
  },
  //route path landing page
  {
    path: 'landing',
    component: LandingPageComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'landing-page-config.json' },
  },

  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'dashboard-config.json' },
  },
  {

    path: 'opportunity-simulator',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { dvmWorkflowAppId: 'opportunity-simulator-config.json' },
  },
  {
    path: 'opportunity-overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { dvmWorkflowAppId: 'opportunity-overview-config.json' },
  },
  {
    path: 'europe-impact-report',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { dvmWorkflowAppId: 'europe-Impact-report.json' },
  },
  {
    path: 'sales-overview',
    component: BarChartComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'new-item',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'new-item.json' },
  },
  {
    path: 'discount-request',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'discount-request.json' },
  },
  {
    path: 'discount-rules',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'discount-rules.json' },
  },
  {
    path: 'deal-performance-tracker',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'deal-performance-tracker.json' },
  },
  {
    path: "AI",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'AI.json' },
  },
  {
    path: 'existing-item',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'existing-item.json' },
  },
  {
    path: 'customer-overview',
    component: DashboardComponent,
    data: { dvmWorkflowAppId: 'customer-overview.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'cspec-bridge',
    component: DashboardComponent,
    data: { dvmWorkflowAppId: 'cspec-bridge.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'cspec-sales-bridge',
    component: DashboardComponent,
    data: { dvmWorkflowAppId: 'cspec-sales-bridge.json' },
    canActivate: [AuthGuard],
  },
  {
    path: 'chat',
    redirectTo: 'chat/sahay',
    pathMatch: 'full',
  },
  {
    path: 'chat/:tab',
    component: ChatTabsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'quotes',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'quotes.json' },
  },
  {
    path: 'quotes-analysis',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'quote-analysis.json' },
  },
  {
    path: 'quote',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'quote.json' },
  },
  {
    path: 'quote-parts',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'quote-parts.json' },
  },
  {
    path: 'definition-template',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'table-dropdown-api-sample.json' },
  },
  {
    path: 'quote-parts-2',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'quote-parts-2.json' },
  },
  {
    path: 'discount-request-final',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'discount-request-final.json' },
  },
  {
    path: 'final-table',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'final-table.json' },
  },
  {
    path: 'final-table.json',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'final-table.json' },
  },
  {
    path: '2-buttons',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: '2-buttons.json' },
  },
  {
    path: 'quote-listing',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'quote-listing.json' },
  },
  {
    path: 'quote-parts-3',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'quote-parts-3.json' },
  },
  {
    path: 'table-spriced',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'table-spriced.json' },
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
